import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, Input, Signal, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { FundsVisibility } from '@components/advanced-fond-list/advanced-fond-list.component';
import { BoTableComponent } from '@components/bo-table/bo-table.component';
import { ElementErrorDirective } from '@components/element-widgets/element-error/element-error.directive';
import { FondsFilterSelections } from '@components/element-widgets/fonds-filters/fonds-filters';
import { HorizontalLayoutComponent } from '@components/layouts/horizontal-layout/horizontal-layout.component';
import { NoSearchResultsComponent } from '@components/no-search-results/no-search-results.component';
import { TranslocoModule } from '@ngneat/transloco';
import { SpacerComponent } from 'src/app/common/components/spacer/spacer.component';
import iconLibrary from 'src/app/common/iconLibrary';
import { ActionFunctions } from 'src/app/table-handling';
import { ShadowStylesDirective } from 'src/boilerplate/shadow-styles.directive';
import { CUID } from 'src/environments/cuids';
import { DOCUMENT_CONSTANTS } from 'src/environments/document-constants';

@Component({
  selector: 'fond-list-widget',
  standalone: true,
  imports: [
    TranslocoModule,
    BoTableComponent,
    HorizontalLayoutComponent,
    SpacerComponent,
    NoSearchResultsComponent,
    ElementErrorDirective,
  ],
  templateUrl: './fond-list-widget.component.html',
  styleUrl: './fond-list-widet.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.ShadowDom,
  hostDirectives: [ShadowStylesDirective],
})
export class FondListWidgetComponent {
  @Input({ required: false }) public allFondsUrl: string = '/fonds';

  protected readonly iconLibrary: string = iconLibrary;
  protected readonly CUID = CUID.fondList;
  protected readonly preconfiguredFilter: Signal<FondsFilterSelections> = signal({
    [DOCUMENT_CONSTANTS.ADVANCED_FUNDS_LIST.ALL_OR_USER_FUNDS_FILTER_TITLE]:
      DOCUMENT_CONSTANTS.ADVANCED_FUNDS_LIST.FUNDS_USER,
  });

  protected readonly fundsVisibility : WritableSignal<FundsVisibility> = signal('user');

  protected readonly cuid: Signal<string> = computed(() => {
    switch(this.fundsVisibility()) {
      case "user":
        return this.CUID.user;
      case "special":
        return this.CUID.special;
    }
    throw 'Unsupported cuid';
  });

  public actionHandler: ActionFunctions = {
    openFund: (funds: string) => {
      const newRelativePath = '/fonds?fund=' + funds;
      window.location.href = window.location.origin + newRelativePath;
    },
  };
}
